// If considering jQuery, Make sure to use document ready or window.onload for StorybookJS to hook into events
(function ($) {

    Drupal.behaviors.stickyHeader = {
        attach: function (context) {
            let elm = document.querySelector('.js-navbar-main', context),
                btn = document.querySelector('.js-navbar-btn'),
                dropdownMenu = document.querySelectorAll('.dropdown-menu'),
                dropdownSubmenu = document.querySelectorAll('.dropdown-submenu'),
                dropdownSubmenuLvl2 = document.querySelectorAll('.dropdown-submenu-lvl-2');

            if(!elm){
                return false;
            }


            btn.addEventListener('click', function(){
                this.classList.toggle('is-open');
                elm.classList.toggle('is-open');

                setTimeout(function () {
                    dropdownMenu.forEach( function (item) {
                        item.classList.remove('show');
                    });

                    dropdownSubmenu.forEach( function (item) {
                        item.classList.remove('show');
                    });

                    dropdownSubmenuLvl2.forEach( function (item) {
                        item.classList.remove('show');
                    });
                }, 100);
            })



            /*
            if(window.scrollY >= threshold){
                elm.classList.add('scrolled');
            }

            function classHandler() {
                if(window.scrollY >= threshold){
                    elm.classList.add('scrolled')

                }else{
                    //elm.classList.remove('scrolled')
                }
            }

            window.addEventListener('scroll', classHandler);
            */
        }
    }
}(jQuery));